import { Task } from '@bringg/types';

import { etaCalculatorProvider } from '../../shared/utils/eta-calculator/eta-calculator-provider';

export const updateEtaAfterTasksCancel = async (selectedTasks: Task[]) => {
	const tasksRoutes = selectedTasks.map(task => task.run_id).filter(runId => !!runId);

	const uniuqeRoutes = new Set(tasksRoutes);

	try {
		await etaCalculatorProvider.getCalculatePlannedEta(Array.from(uniuqeRoutes));
	} catch (e) {
		console.error('Failed to calculate eta or refresh data', e);
	}
};
